var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-bottom-buttons"},[_c('div',{staticClass:"back-to-button to-up-btn",on:{"click":_vm.handleUpButtonClick}},[_c('i',{staticClass:"icon el-icon-top"})]),_c('div',{staticClass:"back-to-button to-down-btn",on:{"click":_vm.handleDownButtonClick}},[_c('i',{staticClass:"icon el-icon-bottom"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }